export const he = {
  common: {
    save: "שמירה",
    cancel: "ביטול",
    delete: "מחיקה",
    edit: "עריכה",
    create: "יצירה",
    add: "הוספה",
    search: "חיפוש",
    filter: "סינון",
    loading: "טוען...",
    error: "שגיאה",
    retry: "נסה שוב",
    back: "חזרה",
    next: "הבא",
    confirm: "אישור",
    close: "סגירה",
    yes: "כן",
    no: "לא",
    active: "פעיל",
    inactive: "לא פעיל",
    required: "שדה חובה",
    optional: "אופציונלי",
    noResults: "לא נמצאו תוצאות",
    addressSearchFailed: "חיפוש הכתובות אינו זמין כרגע. נסו שוב מאוחר יותר.",
    actions: "פעולות",
    details: "פרטים",
    status: "סטטוס",
    total: "סה״כ",
    items: "פריטים",
    submit: "שליחה",
    upload: "העלאה",
    remove: "הסרה",
    poweredBy: "פותח ע״י Level App",
  },
  offline: {
    banner: "אין חיבור לאינטרנט — חלק מהפעולות אינן זמינות",
    actionDisabled: "דרוש חיבור לאינטרנט",
  },
  auth: {
    login: "התחברות",
    register: "הרשמה",
    logout: "התנתקות",
    phone: "מספר טלפון",
    phoneHint: "הזן את מספר הטלפון שלך",
    otp: "קוד אימות",
    otpHint: "הזן את הקוד שנשלח לטלפון שלך",
    sendOtp: "שליחת קוד",
    resendOtp: "שליחה מחדש",
    verify: "אימות",
    createAccount: "יצירת חשבון עסק",
    welcomeBack: "ברוך שובך",
    welcomeTitle: "BiDi לעסקים",
    welcomeSubtitle: "נהל את העסק שלך בקלות",
    sessionExpired: "הפגיש פגה, אנא התחבר מחדש",
    fullName: "שם מלא",
    email: "אימייל",
    password: "סיסמה",
    businessName: "שם העסק",
    address: "כתובת",
    businessRegistrationNumber: "ח.פ.",
    alreadyHaveAccount: "כבר יש לך חשבון?",
    noAccount: "אין לך חשבון?",
    resendIn: "שליחה מחדש בעוד {{seconds}} שניות",
    noBusinessAccount:
      "לא נמצא חשבון עסק המשויך למספר הטלפון הזה. יש להזין את מספר הטלפון של בעל העסק.",
  },
  nav: {
    dashboard: "לוח בקרה",
    orders: "הזמנות",
    orderHistory: "היסטוריית הזמנות",
    reviews: "ביקורות",
    menu: "תפריט",
    profile: "פרופיל עסקי",
    cityConfigs: "הגדרות ערים",
    settings: "הגדרות",
    collapseSidebar: "כווץ",
    expandSidebar: "הרחב",
  },
  reviews: {
    title: "ביקורות",
    empty: "אין ביקורות עדיין",
    emptyDescription: "ביקורות מלקוחות יופיעו כאן",
    anonymous: "לקוח",
  },
  cityConfigs: {
    title: "הגדרות מינימום הזמנה לפי עיר",
    description: "הגדר את סכום ההזמנה המינימלי לכל עיר שאתה משלח אליה",
    addCity: "הוספת עיר",
    city: "עיר",
    selectCity: "בחר עיר",
    minimumOrder: "מינימום הזמנה",
    deliveryFee: "דמי משלוח",
    saved: "נשמר בהצלחה",
    deleted: "נמחק בהצלחה",
  },
  dashboard: {
    title: "לוח בקרה",
    newOrders: "הזמנות חדשות",
    activeOrders: "הזמנות פעילות",
    todayOrders: "הזמנות היום",
    operationStatus: "סטטוס פעילות",
    regular: "פעיל",
    manuallyClosed: "סגור ידנית",
    pausedOrders: "הזמנות מושהות",
    preparationTime: "זמן הכנה (דקות)",
    updatePrepTime: "עדכן",
    quickActions: "פעולות מהירות",
    viewAllOrders: "צפה בכל ההזמנות",
    editMenu: "ערוך תפריט",
    editProfile: "ערוך פרופיל",
    stats: {
      title: "סטטיסטיקות",
      subtitle: "מבוסס על הזמנות בסטטוס נמסרה בתקופה שנבחרה",
      topDishes: "המנות הנמכרות ביותר (עד 5)",
      topAreas: "אזורים מובילים (עד 5)",
      quantityValue: "{{count}} יח׳",
      ordersValue: "{{count}} הזמנות",
      pickupArea: "איסוף עצמי",
      unknownCity: "עיר לא צוינה",
      empty: "אין נתונים לתקופה זו",
    },
  },
  orders: {
    title: "הזמנות",
    empty: "אין הזמנות עדיין",
    emptyDescription: "הזמנות חדשות יופיעו כאן",
    emptyColumn: "אין הזמנות",
    searchPlaceholder: "חיפוש לפי מספר הזמנה...",
    columns: {
      inPreparation: "בהכנה",
      readyForPickup: "מוכן לאיסוף",
    },
    orderNumber: "הזמנה #{{number}}",
    new: "חדשה",
    accepted: "התקבלה",
    inPreparation: "בהכנה",
    readyForPickup: "מוכנה לאיסוף",
    courierAssigned: "שליח שובץ",
    pickedUp: "נאספה",
    delivered: "נמסרה",
    cancelled: "בוטלה",
    accept: "קבל הזמנה",
    reject: "דחה הזמנה",
    startPreparation: "התחל הכנה",
    markReady: "סמן כמוכנה",
    markDelivered: "סמן כנמסרה",
    cancelOrder: "בטל הזמנה",
    confirmCancel: "האם אתה בטוח שברצונך לבטל הזמנה זו?",
    creditCustomer: "זיכוי ללקוח",
    creditDescription: "הזן סכום זיכוי שיירשם ללקוח בהקשר של הזמנה זו.",
    creditAmountLabel: "סכום זיכוי (₪)",
    confirmCredit: "אשר זיכוי",
    creditAmountInvalid: "יש להזין סכום זיכוי חיובי",
    creditSuccess: "הזיכוי נרשם בהצלחה",
    subtotal: "סכום ביניים",
    deliveryFee: "דמי משלוח",
    totalAmount: "סה״כ לתשלום",
    paymentMethod: "אמצעי תשלום",
    creditCard: "כרטיס אשראי",
    cash: "מזומן",
    notes: "הערות",
    noNotes: "אין הערות",
    customer: "לקוח",
    customerPhone: "טלפון לקוח",
    orderType: "סוג הזמנה",
    deliveryAddress: "כתובת למשלוח",
    delivery: "משלוח",
    pickup: "איסוף עצמי",
    statusTimeline: "היסטוריית סטטוס",
    courierInfo: "פרטי שליח",
    courierName: "שם השליח",
    courierPhone: "טלפון שליח",
    estimatedPickup: "זמן הגעה משוער",
    customerReview: "ביקורת לקוח",
    reviewRating: "דירוג",
    noReviewYet: "אין ביקורת עדיין",
    history: "היסטוריה",
    historyTitle: "היסטוריית הזמנות",
    historyEmpty: "אין הזמנות בהיסטוריה",
    historyEmptyDescription: "הזמנות שהושלמו או בוטלו יופיעו כאן",
    dateRange: {
      label: "טווח תאריכים",
      thisWeek: "השבוע",
      lastWeek: "שבוע שעבר",
      thisMonth: "החודש",
      lastMonth: "חודש שעבר",
      custom: "מותאם אישית",
      from: "מתאריך",
      to: "עד תאריך",
    },
    date: "תאריך",
    itemCount: "{{count}} פריטים",
    showDetails: "הצג פרטי הזמנה",
    newOrderTitle: "הזמנה חדשה התקבלה!",
    newOrderDescription: "בחר האם לקבל או לבטל את ההזמנה",
    moreNewOrders: "ועוד {{count}} הזמנות חדשות ממתינות",
    statuses:{
      new: "חדשה",
      New: "חדשה",
      accepted: "התקבלה",
      Accepted: "התקבלה",
      inPreparation: "בהכנה",
      InPreparation: "בהכנה",
      readyForPickup: "מוכנה לאיסוף",
      ReadyForPickup: "מוכנה לאיסוף",
      delivered: "נמסרה",
      Delivered: "נמסרה",
      cancelled: "בוטלה",
      Cancelled: "בוטלה",
    }
  },
  menu: {
    title: "תפריט",
    categoriesTitle: "קטגוריות",
    itemsTitle: "פריטי תפריט",
    addCategory: "הוסף קטגוריה",
    addItem: "הוסף פריט",
    editCategory: "ערוך קטגוריה",
    editItem: "ערוך פריט",
    newCategory: "קטגוריה חדשה",
    newItem: "פריט חדש",
    categoryName: "שם הקטגוריה",
    itemName: "שם הפריט",
    description: "תיאור",
    price: "מחיר",
    image: "תמונה",
    tags: "תגיות",
    selectTags: "בחר תגיות",
    noTagsAvailable: "אין תגיות זמינות",
    optionsGroups: "קבוצות תוספות",
    menuItemOptions: "אפשרויות",
    addOptionsGroup: "הוסף קבוצת תוספות",
    addMenuItemOption: "הוסף אפשרות",
    optionsGroupName: "שם הקבוצה",
    optionName: "שם האפשרות",
    minSelections: "בחירות מינימום",
    maxSelections: "בחירות מקסימום",
    sortOrder: "סדר מיון",
    reorder: "שנה סדר",
    noCategories: "אין קטגוריות עדיין",
    noCategoriesDescription: "הוסף את הקטגוריה הראשונה שלך",
    noItems: "אין פריטים בקטגוריה זו",
    noItemsDescription: "הוסף את הפריט הראשון שלך",
    deleteCategory: "מחק קטגוריה",
    deleteItem: "מחק פריט",
    confirmDeleteCategory: "האם אתה בטוח שברצונך למחוק קטגוריה זו?",
    confirmDeleteItem: "האם אתה בטוח שברצונך למחוק פריט זה?",
    hebrewTab: "עברית",
    englishTab: "אנגלית",
    arabicTab: "ערבית",
    russianTab: "רוסית",
    editOptionsGroup: "ערוך קבוצת תוספות",
    editMenuItemOption: "ערוך אפשרות",
    deleteOptionsGroup: "מחק קבוצת תוספות",
    deleteMenuItemOption: "מחק אפשרות",
    confirmDeleteOptionsGroup:
      "האם אתה בטוח שברצונך למחוק קבוצת תוספות זו וכל האפשרויות שלה?",
    confirmDeleteMenuItemOption:
      "האם אתה בטוח שברצונך למחוק אפשרות זו?",
    noOptionsGroups: "אין קבוצות תוספות עדיין",
    noOptionsGroupsDescription: "הוסף קבוצות תוספות כדי לאפשר ללקוחות להתאים את הפריט",
    noOptions: "אין אפשרויות בקבוצה זו עדיין",
    optionPrice: "מחיר נוסף",
    saveItemFirst: "שמור את הפריט תחילה כדי לנהל קבוצות תוספות",
    reorderError: "שגיאה בשמירת הסדר החדש",
    dragToReorder: "גרור לשינוי סדר",
    toggleActiveError: "שגיאה בעדכון הסטטוס",
    allowDuplicateSelections: "אפשר בחירת אותה אפשרות מספר פעמים",
    deactivateTitle: "השבתה",
    deactivateDescription: "בחר למשך כמה זמן להשבית",
    deactivateIndefinite: "ללא הגבלה",
    deactivateTimed: "למשך זמן מוגדר",
    deactivateHours: "שעות",
    deactivateConfirm: "השבת",
    deactivateCancel: "ביטול",
  },
  profile: {
    title: "פרופיל עסקי",
    businessInfo: "פרטי העסק",
    contactInfo: "פרטי יצירת קשר",
    deliverySettings: "הגדרות משלוח",
    bankDetails: "פרטי בנק",
    workingHoursTitle: "שעות פעילות",
    name: "שם העסק",
    description: "תיאור",
    logo: "לוגו",
    coverImage: "תמונת כיסוי",
    phone: "טלפון",
    email: "אימייל",
    contactType: "ערוץ יצירת קשר",
    contactTypeNone: "לא הוגדר",
    contactTypeWhatsapp: "וואטסאפ",
    contactTypePhone: "טלפון",
    contactTypeEmail: "אימייל",
    contactValuePhone: "מספר טלפון",
    contactValueEmail: "כתובת אימייל",
    contactInvalidEmail: "כתובת אימייל לא תקינה",
    contactInvalidPhone: "מספר טלפון לא תקין",
    address: "כתובת",
    registrationNumber: "ח.פ.",
    kosherStatus: "כשרות",
    kosher: "כשר",
    kosherLeMehadrin: "כשר למהדרין",
    badatz: 'בד"ץ',
    mehadrinMinHaMehadrin: "מהדרין מן המהדרין",
    rabbanut: "רבנות",
    rabbanutMehadrin: "רבנות מהדרין",
    notKosher: "לא כשר",
    none: "לא צוין",
    estimatedPreparationTime: "זמן הכנה משוער (דקות)",
    businessPhone: "טלפון בית עסק",
    ownerPhone: "טלפון בעל העסק",
    minimumOrder: "סכום הזמנה מינימלי",
    acceptsCash: "מקבל מזומן",
    bankHolderName: "שם בעל החשבון",
    bankNumber: "מספר בנק",
    branchNumber: "מספר סניף",
    accountNumber: "מספר חשבון",
    sunday: "ראשון",
    monday: "שני",
    tuesday: "שלישי",
    wednesday: "רביעי",
    thursday: "חמישי",
    friday: "שישי",
    saturday: "שבת",
    openTime: "פתיחה",
    closeTime: "סגירה",
    closed: "סגור",
    addHours: "הוסף שעות",
  },
  settings: {
    title: "הגדרות",
    language: "שפה",
    notifications: "התראות",
    enableNotifications: "הפעל התראות",
    notificationsDescription: "קבל התראות על הזמנות חדשות",
    about: "אודות",
    version: "גרסה",
    hebrew: "עברית",
    english: "English",
    russian: "Русский",
    arabic: "العربية",
  },
  approval: {
    pendingTitle: "ממתין לאישור",
    pendingDescription:
      "החשבון העסקי שלך ממתין לאישור מנהל המערכת. נעדכן אותך ברגע שהחשבון יאושר.",
    blockedTitle: "חשבון חסום",
    blockedDescription:
      "החשבון העסקי שלך חסום. אנא צור קשר עם מנהל המערכת לקבלת מידע נוסף.",
    contactAdmin: "צור קשר עם מנהל",
  },
  validation: {
    required: "שדה חובה",
    minLength: "מינימום {{min}} תווים",
    maxLength: "מקסימום {{max}} תווים",
    invalidPhone: "מספר טלפון לא תקין",
    invalidEmail: "כתובת אימייל לא תקינה",
    invalidPrice: "מחיר לא תקין",
    minValue: "ערך מינימלי: {{min}}",
    maxValue: "ערך מקסימלי: {{max}}",
    fileTooLarge: "הקובץ גדול מדי (מקסימום {{max}}MB)",
    invalidFileType: "סוג קובץ לא נתמך",
  },
  appPreview: {
    title: "תצוגה מקדימה באפליקציה",
    description: "כך הלקוחות רואים את העסק שלך באפליקציית BiDi",
    openPreview: "תצוגה מקדימה",
    editProfile: "ערוך פרופיל",
    editMenu: "ערוך תפריט",
    searchPlaceholder: "מחפשים מנה ספציפית?",
    openNow: "פתוח עכשיו",
    minimumOrder: "מינימום הזמנה",
    minutes: "דק׳",
    noItems: "אין פריטים בקטגוריה זו",
  },
  errors: {
    generic: "משהו השתבש, אנא נסה שוב",
    network: "שגיאת רשת, בדוק את החיבור לאינטרנט",
    unauthorized: "אין הרשאה, אנא התחבר מחדש",
    forbidden: "אין לך הרשאה לבצע פעולה זו",
    notFound: "הדף המבוקש לא נמצא",
    serverError: "שגיאת שרת, אנא נסה מאוחר יותר",
  },
};
